import { mapNullStrToZero, arrOutOfScope } from "../commonService";

export default function prescriptionLimit({
    isRless,
    isFolding,
    rx,
    isBlush = false,
}: {
    isRless: boolean;
    isFolding: boolean;
    rx: any;
    isBlush?: boolean;
}) {
    let res = {
        bool: true,
        title: "CAN_NOT_BUY_RIMLESS_TIPS",
    };
    let { os_sph, od_sph, os_cyl, od_cyl } = rx;
    os_sph = mapNullStrToZero(os_sph);
    od_sph = mapNullStrToZero(od_sph);
    os_cyl = mapNullStrToZero(os_cyl);
    od_cyl = mapNullStrToZero(od_cyl);
    // 腮红眼镜填的处方只要有一项不在指定范围内，就不能买
    if (isBlush) {
        res.bool = !arrOutOfScope([os_sph, od_sph], { min: -6.0, max: 0 });
        res.title = "CAN_NOT_BUY_BLUSH_TIPS";
    }
    // 无框眼镜填的处方只要有一项不在指定范围内，就不能买
    if (isRless) {
        res.bool =
            !arrOutOfScope([os_sph, od_sph], { min: -6.0, max: 4.0 }) &&
            !arrOutOfScope([os_cyl, od_cyl], { min: -4.0, max: 0 });
        res.title = "CAN_NOT_BUY_RIMLESS_TIPS";
    }
    //Folding readers规则：|DS|+|DC|<=+6.00
    if (isFolding) {
        res.bool =
            Math.abs(os_sph) + Math.abs(os_cyl) <= 6 &&
            Math.abs(od_sph) + Math.abs(od_cyl) <= 6;
        res.title = "CAN_NOT_BUY_FOLDING_TIPS";
    }

    res.bool = !res.bool;

    return res;
}
